import { Download } from "lucide-react";

export default function AttendanceHeader({ onExportOpen }) {
  return (
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
        Manage Attendance
      </h2>

      <div className="flex gap-2">
        <button
          onClick={onExportOpen}
          className="rounded-lg border px-3 py-2 text-sm hover:bg-gray-50 dark:text-white dark:hover:bg-white/10"
        >
          <Download className="mr-2 inline-block h-4 w-4" /> Export
        </button>

        <button className="rounded-lg bg-gradient-to-r from-[#ef145d] to-[#e3955e] px-3 py-2 text-sm text-white hover:bg-orange-600">
          Report
        </button>
      </div>
    </div>
  );
}
